// ABOUTME: The one place the signed-in interview card picks its API: pro-core's (./api), or the mock layer's in a dev
// ABOUTME: build that names `interviews` in VITE_MOCK_API. The guest variant always talks to pro-core.
import { mockRegistry } from 'mocks/registry';
import { createTalentInterviewApi as createReal } from './api';

export const createTalentInterviewApi =
  mockRegistry.apis.interviews ?? createReal;
